import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const stuRegistration = {
    major: {
        queryList: config => createAPI('/skillRecognition/xsbm/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/xsbm/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/xsbm/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/xsbm/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/xsbm/releaseRecById', 'post', config),
        queryById: config => createAPI('/skillRecognition/xsbm/queryById', 'post', config),
        queryKskcbById: config => createAPI('/skillRecognition/xsbm/queryKskcbById', 'post', config),
        saveXsbm: config => createAPI('/skillRecognition/xsbm/saveXsbm', 'post', config),
    },
};

export default stuRegistration;



// WEBPACK FOOTER //
// ./src/api/modules/stuRegistration.js